"use client";
import { useEffect, useRef, useState } from "react";
import useMeasure from "react-use-measure";
import { twMerge } from "tailwind-merge";

type Stage = "open" | "grayed" | "collapse-rest" | "collapse-co" | "done";

function Letter({
    text,
    collapsed,
    colored,
}: {
    text: string;
    collapsed?: boolean;
    colored?: boolean;
}) {
    const [ref, innerBounds] = useMeasure();

    return (
        <div
            className={twMerge(
                "inline-block overflow-hidden transition-all duration-500"
            )}
            style={{
                width: collapsed
                    ? 0
                    : innerBounds.width === 0
                    ? "auto"
                    : innerBounds.width,
            }}
        >
            <span
                ref={ref}
                className={twMerge(
                    "font-geist-mono transition-all duration-500 inline-block whitespace-pre",
                    collapsed ? "opacity-0" : "opacity-100",
                    colored ? "text-foreground" : "text-background-2"
                )}
            >
                {text}
            </span>
        </div>
    );
}

function MultiLetter({
    text,
    collapsed,
    colored,
}: {
    text: string;
    collapsed?: boolean;
    colored?: boolean;
}) {
    return text
        .split("")
        .map((char, index) => (
            <Letter
                key={index}
                text={char}
                collapsed={collapsed}
                colored={colored}
            />
        ));
}

export default function HaiiiCollapse() {
    const [stage, setStage] = useState<Stage>("open");

    const initialAnimationDone = useRef(false);

    function collapseAnimation() {
        let t1 = setTimeout(() => setStage("grayed"), 800);
        let t2 = setTimeout(() => setStage("collapse-co"), 1600);
        let t3 = setTimeout(() => {
            setStage("done");
            initialAnimationDone.current = true;
        }, 2400);

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
        };
    }

    useEffect(() => {
        return collapseAnimation();
    }, []);

    if (stage === "done") {
        return (
            <div
                className="flex justify-left text-md lg:text-xl cursor-pointer"
                onMouseEnter={() => {
                    if (!initialAnimationDone.current) return;
                    setStage("collapse-co");
                    setTimeout(() => {
                        setStage("open");
                    }, 100);
                }}
            >
                <span className="font-geist-mono text-foreground ">haiii</span>
            </div>
        );
    }

    return (
        <div
            id="bruh"
            className="flex justify-left text-md lg:text-xl cursor-pointer"
            onMouseLeave={() => {
                if (!initialAnimationDone.current) return;
                initialAnimationDone.current = false;
                collapseAnimation();
            }}
        >
            <MultiLetter
                text="the "
                collapsed={stage.startsWith("collapse")}
                colored={stage === "open"}
            />

            <Letter text="h" colored />
            <MultiLetter
                text="uman"
                collapsed={stage.startsWith("collapse")}
                colored={stage === "open"}
            />

            <Letter text=" " collapsed={stage.startsWith("collapse")} />

            <Letter text="ai" colored />

            <Letter text=" " collapsed={stage.startsWith("collapse")} />

            <Letter text="i" colored />
            <MultiLetter
                text="nteraction"
                collapsed={stage.startsWith("collapse")}
                colored={stage === "open"}
            />

            <Letter text=" " collapsed={stage.startsWith("collapse")} />

            <Letter text="i" colored />
            <MultiLetter
                text="nterface"
                collapsed={stage.startsWith("collapse")}
                colored={stage === "open"}
            />

            <Letter text=" " collapsed={stage.startsWith("collapse")} />

            <Letter text="co" colored collapsed={stage === "collapse-co"} />
            <MultiLetter
                text="mpany"
                collapsed={stage.startsWith("collapse")}
                colored={stage === "open"}
            />
        </div>
    );
}
